export type PatentProcedureType = "EP1001" | "EP1200"

// Names shown to customers: no form numbers
export const PATENT_PROCEDURE_LABELS: Record<PatentProcedureType, string> = {
  EP1001: "Filing EP patent (direct or claiming national priority)",
  EP1200: "PCT nationalisation (EURO-PCT)"
}

export function getPatentProcedureLabel(procedureType?: string | null) {
  return PATENT_PROCEDURE_LABELS[procedureType === "EP1200" ? "EP1200" : "EP1001"]
}
